import { useQuery } from '@tanstack/react-query';

import { QUERY_KEY } from '../constants/cacheKeys.const';
import { STABLE_QZ_QUERY_SETTINGS } from '../constants/qzQuery.const';
import { listWorkstations } from '../services/workstation.service';
import { type Workstation } from '../types/print.type';
import { usePrintSetup } from './usePrintSetup';

const EMPTY_WORKSTATIONS: Workstation[] = [];

export const useWorkstations = () => {
  const { connectionStatus, isKnownInstallation } = usePrintSetup();

  const query = useQuery({
    enabled: connectionStatus === 'connected' || isKnownInstallation,
    queryFn: listWorkstations,
    queryKey: QUERY_KEY.useWorkstations,
    select: (response) => response.workstations,
    ...STABLE_QZ_QUERY_SETTINGS,
  });

  return { query, workstations: query.data ?? EMPTY_WORKSTATIONS };
};
